'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Image } from '../Image';
import { ProgressiveAssetController } from './ProgressiveAssetController';
import { ProgressiveAssetWrapper } from './ProgressiveAssetWrapper';
import { Image as StyledImage } from './styles';
const ImageView = props => {
    const { completeLoading, hasLoaded } = ProgressiveAssetController.useContainer();
    const imageRef = React.useRef(null);
    React.useEffect(() => {
        if (imageRef.current?.complete) {
            completeLoading();
        }
    }, [completeLoading, imageRef]);
    return (_jsx(Image, { hasLoaded, ...props, imageComponent: StyledImage, onLoad: completeLoading, ref: imageRef, "data-progressive-image": true }));
};
export const ProgressiveAssetImage = ({ aspectRatios, ...rest }) => {
    return (_jsx(ProgressiveAssetWrapper, { aspectRatios: aspectRatios, children: _jsx(ImageView, { ...rest }) }));
};
//# sourceMappingURL=ProgressiveAssetImage.js.map